import { alpha, display, maxWidth, positions, width } from "@mui/system";
const styles = (theme) => ({
  pageBox: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    maxWidth: "100%",
  },
  searchBarContainer: {
    width: "calc(100% + 32px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 0,
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    backdropFilter: "blur(6px)",
    gap: 2,
    padding: 2,
    position: "relative",
    top: -16,
    left: -16,
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
  // Primeira linha de uma opção de cliente: nome à esquerda, selo PF/PJ (ou de
  // grupo econômico) à direita, sem deixar o selo ser espremido pelo nome.
  linhaNomeOpcao: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.75,
    width: "100%",
    minWidth: 0,
  },
  formMenu: {
    width: "100%",
    fontSize: "0.75rem", // diminui fonte geral
  },
  filterGroupItem: {
    width: "310px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  newClientButton: { height: "40px" },
  perfilTabs: {
    display: "flex",
    flexDirection: "row",
    gap: 0,
    width: "100%",
    maxWidth: "100vw",
  },
  newClientFloatingMobileButton: {
    position: "fixed",
    bottom: "30px",
    right: "30px",
  },
  filterTypography: {
    textWrap: "nowrap",
  },
  formControl: {
    display: "flex",
    width: "120px",
    minWidth: "120px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "primary",
      color: "primary",
    },
    "& .MuiInputLabel-root": {
      color: "primary",
    },
    svg: {
      color: "primary",
    },
    input: {
      color: "primary",
    },
  },
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    gap: 2,
  },
  content: { gap: "20px", display: "flex", flexDirection: "column" },
  paper: {
    display: "flex",
    flexDirection: "column",
    padding: "24px 24px 26px",
    bgcolor: theme.palette.mode === "dark" ? "transparent" : "none",
    gap: "16px",
    borderRadius: "10px",
    width: "310px",
    minWidth: "310px",
    position: "sticky",
    top: 130,
    height: "100%",
  },
  avatar: { width: "64px", height: "64px" },

  Icon: {
    fontSize: "26px",
  },

  configBadge: {
    fontSize: "18px",
    position: "absolute",
    bottom: 4,
    right: -8,
  },
  selectedList: {
    color: theme.palette.secondary.main,
    "&.Mui-selected": {
      backgroundColor: "transparent",
    },
  },
  listIconWanguard: { fontSize: "32px", ml: -0.5 },
  infoContratos: {
    marginLeft: "4px",
    width: "15px",
  },
  boxFilters: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    "@media (max-width: 1350px)": {
      flexDirection: "column",
    },

    width: "100%",
  },
  searchField: {
    width: "100%",
    maxWidth: 500,

    display: "flex",

    fontSize: "0.75rem", // diminui fonte geral
  },

  configStatusSelect: {
    width: "100%",

    fontSize: "0.75rem",

    "@media (max-width: 1350px)": {
      width: "100%",
    },
  },
  configStatusChipSuccess: {
    height: 18,
    fontSize: "0.65rem",
    fontWeight: "bold",
    bgcolor: "success.light",
    color: "success.contrastText",
  },
  configStatusChipGray: {
    height: 18,
    fontSize: "0.65rem",
    fontWeight: "bold",
    bgcolor: theme.palette.colors.gray.dark,
    color: "#fff",
  },
});

export default styles;
